/**
 * Colors
 */

const woodsmoke = '#101015';
const manatee = '#8A8F99';
const cadetBlue = '#B2B8C2';
const geyser = '#D2D9E1';
const athensgray = '#E4E8ED';
const aquahaze = '#F0F4F7';
const popesmoke = '#F9FAFB';
const dodgerblue = '#4487FF';
const aliceblue = '#F5FAFF';
const carnation = '#F75B5B';
const chablis = '#FFF5F5';
const bermuda = '#75DBBE';

export const blackHex = woodsmoke;
export const darkHex = woodsmoke;
export const bw8Hex = woodsmoke;
export const bw7Hex = manatee;
export const bw6Hex = cadetBlue;
export const bw5Hex = geyser;
export const bw4Hex = athensgray;
export const bw3Hex = aquahaze;
export const bw2Hex = popesmoke;
export const bw1Hex = 'white';
export const whiteHex = 'white';
export const accentHex = dodgerblue;
export const accentSubtleHex = aliceblue;
export const dangerousHex = carnation;
export const dangerousSubtleHex = chablis;
export const positiveHex = bermuda;
export const defaultHex = woodsmoke;

export const black: Color = 'bw8';
export const bw8: Color = 'bw8';
export const bw7: Color = 'bw7';
export const bw6: Color = 'bw6';
export const bw5: Color = 'bw5';
export const bw4: Color = 'bw4';
export const bw3: Color = 'bw3';
export const bw2: Color = 'bw2';
export const bw1: Color = 'bw1';
export const white: Color = 'bw1';
export const accent: Color = 'accent';
export const accent2: Color = 'accent2';
export const accentSubtle: Color = 'accent-subtle';
export const dangerous: Color = 'dangerous';
export const dangerousSubtle: Color = 'dangerous-subtle';
export const positive: Color = 'positive';
export const defaultColor: Color = 'default';
export const transparent: Color = 'transparent';

export function getTextColorClassName(textColor?: Color) {
  return textColor ? `color--${textColor}` : '';
}

export function getBackgroundColorClassName(bgColor?: Color) {
  return bgColor ? `bgcolor--${bgColor}` : '';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/styles/colors.ts